import React from "react"
import PropTypes from "prop-types"

const TruncateString = ({ text, at = 50, showTitle = true }) => {
  return (
    <div title={showTitle && text?.length > at ? text : ""}>
      {text?.length > at ? `${text.substring(0, at)} ...` : text}
    </div>
  )
}

TruncateString.propTypes = {
  text: PropTypes.string,
  at: PropTypes.number, // truncate at this point
  showTitle: PropTypes.bool, // show the full text in the title but only if its longer than the to value
}

export default TruncateString
